import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $textcolor?: string;
}

export const MenuBarItem = styled.div<IProps>`
  .area-click {
    font-weight: 500;
    line-height: 130%;
    color: #000;
    height: 100%;
    font-size: 15px;
    padding: 7px 10px;
    -webkit-user-select: none;
    user-select: none;
  }

  &.dot .area-click::after {
    content: '';
    display: inline-block;
    border-radius: 50%;
    background-color: #fa5500;
    width: 4px;
    height: 4px;
    margin-left: 2px;
    transform: translateY(-7px);
  }

  ${props => {
    if (typeof props.$textcolor === 'string' && props.$textcolor !== '') {
      return css`
        .area-click {
          color: ${props.$textcolor};
        }

        &.active {
          .area-click {
            background-color: ${props.$textcolor} !important;
          }
        }
      `;
    }
    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    .area-click {
      font-size: ${mixin.pxToVw('15')};
      padding: ${mixin.pxToVw('7 10')};
    }

    &.dot .area-click::after {
      width: ${mixin.pxToVw('4')};
      height: ${mixin.pxToVw('4')};
      margin-left: ${mixin.pxToVw('2')};
      transform: translateY(${mixin.pxToVw('-8')});
    }
  }
`;
